import { ReactNode } from 'react';
import { Backdrop, BackdropProps, Container, Stack } from '@mui/material';
import { useTheme } from '../../hooks';

interface Props extends BackdropProps {
    children: ReactNode;
}

const BaseBackdrop = ({ children, ...backdropProps }: Props) => {
    const { colors, spacing, zIndex } = useTheme();
    return (
        <Backdrop sx={{ zIndex: zIndex.modal }} {...backdropProps}>
            <Container
                sx={{
                    width: 400,
                    backgroundColor: colors.primaryContainer,
                    padding: spacing(3),
                    borderRadius: spacing(2)
                }}
            >
                <Stack spacing={2}>{children}</Stack>
            </Container>
        </Backdrop>
    );
};

export { BaseBackdrop };
